// extracted by extract-css-chunks-webpack-plugin
module.exports = {"lead":"onboarding-info-modal__lead___3neRq"};
    if(module.hot) {
      // 1792097749005
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  